import React,{PureComponent} from 'react'
import {Switch,Route, Redirect} from 'react-router-dom'

import Sale from "@pages/OrderManagement/Sale/OrderSale";
import OrderDirectSale from "@pages/OrderManagement/DirectSale/OrderDirectSale";
import PoDetail from "@pages/Po/PoDetail/index";

import ExceptionPendingOrder from "@pages/OrderManagement/ExceptionPendingOrder/ExceptionPendingOrder";
import ExceptionPendingOrderDetail from "@pages/OrderManagement/ExceptionPendingOrder/Detail/Detail";

import HighRiskOrderList from "@pages/OrderManagement/highRiskOrder/list";
import CancelRecordDetails from "@pages/CancelRecord/Details/index";
import CancelRecordAddNew from "@pages/CancelRecord/AddNew/index";

class OrderRouter extends PureComponent{
    render() {
        return (
            <Switch>
                <Route path="/order/sale/detail" component={PoDetail} />
                <Route path="/order/sale" component={Sale} />
                <Route path="/order/directSale" component={OrderDirectSale} />
                <Route path="/order/exceptionPendingOrder/detail" component={ExceptionPendingOrderDetail} />
                <Route path="/order/exceptionPendingOrder" component={ExceptionPendingOrder} />
                <Route path="/order/cancelRecord/details" component={CancelRecordDetails} />
                <Route path="/order/cancelRecord/addNew" component={CancelRecordAddNew} />
                <Route path="/order/highRiskOrder/list" component={HighRiskOrderList} />
                <Route path="/*" render={(props) => <Redirect to="/order/exceptionPendingOrder" />} />
            </Switch>
        );
    }
}
export default OrderRouter;